/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitAppRequest = /* GraphQL */ `mutation SubmitAppRequest($app_name: String, $username: String) {
  submitAppRequest(app_name: $app_name, username: $username)
}
` as GeneratedMutation<
  APITypes.SubmitAppRequestMutationVariables,
  APITypes.SubmitAppRequestMutation
>;
export const sendNotification = /* GraphQL */ `mutation SendNotification($msg: String, $habitatID: String) {
  sendNotification(msg: $msg, habitatID: $habitatID) {
    msg
    habitatID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendNotificationMutationVariables,
  APITypes.SendNotificationMutation
>;
export const signupAccount = /* GraphQL */ `mutation SignupAccount($data: AWSJSON) {
  signupAccount(data: $data)
}
` as GeneratedMutation<
  APITypes.SignupAccountMutationVariables,
  APITypes.SignupAccountMutation
>;
export const updateAccount = /* GraphQL */ `mutation UpdateAccount($data: AWSJSON) {
  updateAccount(data: $data)
}
` as GeneratedMutation<
  APITypes.UpdateAccountMutationVariables,
  APITypes.UpdateAccountMutation
>;
export const deleteAccount = /* GraphQL */ `mutation DeleteAccount($data: AWSJSON) {
  deleteAccount(data: $data)
}
` as GeneratedMutation<
  APITypes.DeleteAccountMutationVariables,
  APITypes.DeleteAccountMutation
>;
export const sendCalendarInvitations = /* GraphQL */ `mutation SendCalendarInvitations($data: AWSJSON) {
  sendCalendarInvitations(data: $data)
}
` as GeneratedMutation<
  APITypes.SendCalendarInvitationsMutationVariables,
  APITypes.SendCalendarInvitationsMutation
>;
export const setLockPIN = /* GraphQL */ `mutation SetLockPIN($params: AWSJSON) {
  setLockPIN(params: $params)
}
` as GeneratedMutation<
  APITypes.SetLockPINMutationVariables,
  APITypes.SetLockPINMutation
>;
export const forgotLockPIN = /* GraphQL */ `mutation ForgotLockPIN($user_id: String) {
  forgotLockPIN(user_id: $user_id)
}
` as GeneratedMutation<
  APITypes.ForgotLockPINMutationVariables,
  APITypes.ForgotLockPINMutation
>;
export const updateState = /* GraphQL */ `mutation UpdateState($data: AWSJSON) {
  updateState(data: $data)
}
` as GeneratedMutation<
  APITypes.UpdateStateMutationVariables,
  APITypes.UpdateStateMutation
>;
export const createAlarm = /* GraphQL */ `mutation CreateAlarm(
  $input: CreateAlarmInput!
  $condition: ModelAlarmConditionInput
) {
  createAlarm(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlarmMutationVariables,
  APITypes.CreateAlarmMutation
>;
export const updateAlarm = /* GraphQL */ `mutation UpdateAlarm(
  $input: UpdateAlarmInput!
  $condition: ModelAlarmConditionInput
) {
  updateAlarm(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlarmMutationVariables,
  APITypes.UpdateAlarmMutation
>;
export const deleteAlarm = /* GraphQL */ `mutation DeleteAlarm(
  $input: DeleteAlarmInput!
  $condition: ModelAlarmConditionInput
) {
  deleteAlarm(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlarmMutationVariables,
  APITypes.DeleteAlarmMutation
>;
export const createAlert = /* GraphQL */ `mutation CreateAlert(
  $input: CreateAlertInput!
  $condition: ModelAlertConditionInput
) {
  createAlert(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAlertMutationVariables,
  APITypes.CreateAlertMutation
>;
export const updateAlert = /* GraphQL */ `mutation UpdateAlert(
  $input: UpdateAlertInput!
  $condition: ModelAlertConditionInput
) {
  updateAlert(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAlertMutationVariables,
  APITypes.UpdateAlertMutation
>;
export const deleteAlert = /* GraphQL */ `mutation DeleteAlert(
  $input: DeleteAlertInput!
  $condition: ModelAlertConditionInput
) {
  deleteAlert(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAlertMutationVariables,
  APITypes.DeleteAlertMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createMeal = /* GraphQL */ `mutation CreateMeal(
  $input: CreateMealInput!
  $condition: ModelMealConditionInput
) {
  createMeal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMealMutationVariables,
  APITypes.CreateMealMutation
>;
export const updateMeal = /* GraphQL */ `mutation UpdateMeal(
  $input: UpdateMealInput!
  $condition: ModelMealConditionInput
) {
  updateMeal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMealMutationVariables,
  APITypes.UpdateMealMutation
>;
export const deleteMeal = /* GraphQL */ `mutation DeleteMeal(
  $input: DeleteMealInput!
  $condition: ModelMealConditionInput
) {
  deleteMeal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMealMutationVariables,
  APITypes.DeleteMealMutation
>;
export const createMealRecipe = /* GraphQL */ `mutation CreateMealRecipe(
  $input: CreateMealRecipeInput!
  $condition: ModelMealRecipeConditionInput
) {
  createMealRecipe(input: $input, condition: $condition) {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMealRecipeMutationVariables,
  APITypes.CreateMealRecipeMutation
>;
export const updateMealRecipe = /* GraphQL */ `mutation UpdateMealRecipe(
  $input: UpdateMealRecipeInput!
  $condition: ModelMealRecipeConditionInput
) {
  updateMealRecipe(input: $input, condition: $condition) {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMealRecipeMutationVariables,
  APITypes.UpdateMealRecipeMutation
>;
export const deleteMealRecipe = /* GraphQL */ `mutation DeleteMealRecipe(
  $input: DeleteMealRecipeInput!
  $condition: ModelMealRecipeConditionInput
) {
  deleteMealRecipe(input: $input, condition: $condition) {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMealRecipeMutationVariables,
  APITypes.DeleteMealRecipeMutation
>;
export const createDashboard = /* GraphQL */ `mutation CreateDashboard(
  $input: CreateDashboardInput!
  $condition: ModelDashboardConditionInput
) {
  createDashboard(input: $input, condition: $condition) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDashboardMutationVariables,
  APITypes.CreateDashboardMutation
>;
export const updateDashboard = /* GraphQL */ `mutation UpdateDashboard(
  $input: UpdateDashboardInput!
  $condition: ModelDashboardConditionInput
) {
  updateDashboard(input: $input, condition: $condition) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDashboardMutationVariables,
  APITypes.UpdateDashboardMutation
>;
export const deleteDashboard = /* GraphQL */ `mutation DeleteDashboard(
  $input: DeleteDashboardInput!
  $condition: ModelDashboardConditionInput
) {
  deleteDashboard(input: $input, condition: $condition) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDashboardMutationVariables,
  APITypes.DeleteDashboardMutation
>;
export const createDomain = /* GraphQL */ `mutation CreateDomain(
  $input: CreateDomainInput!
  $condition: ModelDomainConditionInput
) {
  createDomain(input: $input, condition: $condition) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDomainMutationVariables,
  APITypes.CreateDomainMutation
>;
export const updateDomain = /* GraphQL */ `mutation UpdateDomain(
  $input: UpdateDomainInput!
  $condition: ModelDomainConditionInput
) {
  updateDomain(input: $input, condition: $condition) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDomainMutationVariables,
  APITypes.UpdateDomainMutation
>;
export const deleteDomain = /* GraphQL */ `mutation DeleteDomain(
  $input: DeleteDomainInput!
  $condition: ModelDomainConditionInput
) {
  deleteDomain(input: $input, condition: $condition) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDomainMutationVariables,
  APITypes.DeleteDomainMutation
>;
export const createFile = /* GraphQL */ `mutation CreateFile(
  $input: CreateFileInput!
  $condition: ModelFileConditionInput
) {
  createFile(input: $input, condition: $condition) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFileMutationVariables,
  APITypes.CreateFileMutation
>;
export const updateFile = /* GraphQL */ `mutation UpdateFile(
  $input: UpdateFileInput!
  $condition: ModelFileConditionInput
) {
  updateFile(input: $input, condition: $condition) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFileMutationVariables,
  APITypes.UpdateFileMutation
>;
export const deleteFile = /* GraphQL */ `mutation DeleteFile(
  $input: DeleteFileInput!
  $condition: ModelFileConditionInput
) {
  deleteFile(input: $input, condition: $condition) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFileMutationVariables,
  APITypes.DeleteFileMutation
>;
export const createGoal = /* GraphQL */ `mutation CreateGoal(
  $input: CreateGoalInput!
  $condition: ModelGoalConditionInput
) {
  createGoal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGoalMutationVariables,
  APITypes.CreateGoalMutation
>;
export const updateGoal = /* GraphQL */ `mutation UpdateGoal(
  $input: UpdateGoalInput!
  $condition: ModelGoalConditionInput
) {
  updateGoal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGoalMutationVariables,
  APITypes.UpdateGoalMutation
>;
export const deleteGoal = /* GraphQL */ `mutation DeleteGoal(
  $input: DeleteGoalInput!
  $condition: ModelGoalConditionInput
) {
  deleteGoal(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGoalMutationVariables,
  APITypes.DeleteGoalMutation
>;
export const createHabitat = /* GraphQL */ `mutation CreateHabitat(
  $input: CreateHabitatInput!
  $condition: ModelHabitatConditionInput
) {
  createHabitat(input: $input, condition: $condition) {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHabitatMutationVariables,
  APITypes.CreateHabitatMutation
>;
export const updateHabitat = /* GraphQL */ `mutation UpdateHabitat(
  $input: UpdateHabitatInput!
  $condition: ModelHabitatConditionInput
) {
  updateHabitat(input: $input, condition: $condition) {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHabitatMutationVariables,
  APITypes.UpdateHabitatMutation
>;
export const deleteHabitat = /* GraphQL */ `mutation DeleteHabitat(
  $input: DeleteHabitatInput!
  $condition: ModelHabitatConditionInput
) {
  deleteHabitat(input: $input, condition: $condition) {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHabitatMutationVariables,
  APITypes.DeleteHabitatMutation
>;
export const createRecipeFavourite = /* GraphQL */ `mutation CreateRecipeFavourite(
  $input: CreateRecipeFavouriteInput!
  $condition: ModelRecipeFavouriteConditionInput
) {
  createRecipeFavourite(input: $input, condition: $condition) {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecipeFavouriteMutationVariables,
  APITypes.CreateRecipeFavouriteMutation
>;
export const updateRecipeFavourite = /* GraphQL */ `mutation UpdateRecipeFavourite(
  $input: UpdateRecipeFavouriteInput!
  $condition: ModelRecipeFavouriteConditionInput
) {
  updateRecipeFavourite(input: $input, condition: $condition) {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecipeFavouriteMutationVariables,
  APITypes.UpdateRecipeFavouriteMutation
>;
export const deleteRecipeFavourite = /* GraphQL */ `mutation DeleteRecipeFavourite(
  $input: DeleteRecipeFavouriteInput!
  $condition: ModelRecipeFavouriteConditionInput
) {
  deleteRecipeFavourite(input: $input, condition: $condition) {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecipeFavouriteMutationVariables,
  APITypes.DeleteRecipeFavouriteMutation
>;
export const createImage = /* GraphQL */ `mutation CreateImage(
  $input: CreateImageInput!
  $condition: ModelImageConditionInput
) {
  createImage(input: $input, condition: $condition) {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateImageMutationVariables,
  APITypes.CreateImageMutation
>;
export const updateImage = /* GraphQL */ `mutation UpdateImage(
  $input: UpdateImageInput!
  $condition: ModelImageConditionInput
) {
  updateImage(input: $input, condition: $condition) {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateImageMutationVariables,
  APITypes.UpdateImageMutation
>;
export const deleteImage = /* GraphQL */ `mutation DeleteImage(
  $input: DeleteImageInput!
  $condition: ModelImageConditionInput
) {
  deleteImage(input: $input, condition: $condition) {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteImageMutationVariables,
  APITypes.DeleteImageMutation
>;
export const createIngredientGroup = /* GraphQL */ `mutation CreateIngredientGroup(
  $input: CreateIngredientGroupInput!
  $condition: ModelIngredientGroupConditionInput
) {
  createIngredientGroup(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIngredientGroupMutationVariables,
  APITypes.CreateIngredientGroupMutation
>;
export const updateIngredientGroup = /* GraphQL */ `mutation UpdateIngredientGroup(
  $input: UpdateIngredientGroupInput!
  $condition: ModelIngredientGroupConditionInput
) {
  updateIngredientGroup(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIngredientGroupMutationVariables,
  APITypes.UpdateIngredientGroupMutation
>;
export const deleteIngredientGroup = /* GraphQL */ `mutation DeleteIngredientGroup(
  $input: DeleteIngredientGroupInput!
  $condition: ModelIngredientGroupConditionInput
) {
  deleteIngredientGroup(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIngredientGroupMutationVariables,
  APITypes.DeleteIngredientGroupMutation
>;
export const createIngredientItem = /* GraphQL */ `mutation CreateIngredientItem(
  $input: CreateIngredientItemInput!
  $condition: ModelIngredientItemConditionInput
) {
  createIngredientItem(input: $input, condition: $condition) {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIngredientItemMutationVariables,
  APITypes.CreateIngredientItemMutation
>;
export const updateIngredientItem = /* GraphQL */ `mutation UpdateIngredientItem(
  $input: UpdateIngredientItemInput!
  $condition: ModelIngredientItemConditionInput
) {
  updateIngredientItem(input: $input, condition: $condition) {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIngredientItemMutationVariables,
  APITypes.UpdateIngredientItemMutation
>;
export const deleteIngredientItem = /* GraphQL */ `mutation DeleteIngredientItem(
  $input: DeleteIngredientItemInput!
  $condition: ModelIngredientItemConditionInput
) {
  deleteIngredientItem(input: $input, condition: $condition) {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIngredientItemMutationVariables,
  APITypes.DeleteIngredientItemMutation
>;
export const createLockPin = /* GraphQL */ `mutation CreateLockPin(
  $input: CreateLockPinInput!
  $condition: ModelLockPinConditionInput
) {
  createLockPin(input: $input, condition: $condition) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLockPinMutationVariables,
  APITypes.CreateLockPinMutation
>;
export const updateLockPin = /* GraphQL */ `mutation UpdateLockPin(
  $input: UpdateLockPinInput!
  $condition: ModelLockPinConditionInput
) {
  updateLockPin(input: $input, condition: $condition) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLockPinMutationVariables,
  APITypes.UpdateLockPinMutation
>;
export const deleteLockPin = /* GraphQL */ `mutation DeleteLockPin(
  $input: DeleteLockPinInput!
  $condition: ModelLockPinConditionInput
) {
  deleteLockPin(input: $input, condition: $condition) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLockPinMutationVariables,
  APITypes.DeleteLockPinMutation
>;
export const createLogEvent = /* GraphQL */ `mutation CreateLogEvent(
  $input: CreateLogEventInput!
  $condition: ModelLogEventConditionInput
) {
  createLogEvent(input: $input, condition: $condition) {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLogEventMutationVariables,
  APITypes.CreateLogEventMutation
>;
export const updateLogEvent = /* GraphQL */ `mutation UpdateLogEvent(
  $input: UpdateLogEventInput!
  $condition: ModelLogEventConditionInput
) {
  updateLogEvent(input: $input, condition: $condition) {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLogEventMutationVariables,
  APITypes.UpdateLogEventMutation
>;
export const deleteLogEvent = /* GraphQL */ `mutation DeleteLogEvent(
  $input: DeleteLogEventInput!
  $condition: ModelLogEventConditionInput
) {
  deleteLogEvent(input: $input, condition: $condition) {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLogEventMutationVariables,
  APITypes.DeleteLogEventMutation
>;
export const createMealPlan = /* GraphQL */ `mutation CreateMealPlan(
  $input: CreateMealPlanInput!
  $condition: ModelMealPlanConditionInput
) {
  createMealPlan(input: $input, condition: $condition) {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMealPlanMutationVariables,
  APITypes.CreateMealPlanMutation
>;
export const updateMealPlan = /* GraphQL */ `mutation UpdateMealPlan(
  $input: UpdateMealPlanInput!
  $condition: ModelMealPlanConditionInput
) {
  updateMealPlan(input: $input, condition: $condition) {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMealPlanMutationVariables,
  APITypes.UpdateMealPlanMutation
>;
export const deleteMealPlan = /* GraphQL */ `mutation DeleteMealPlan(
  $input: DeleteMealPlanInput!
  $condition: ModelMealPlanConditionInput
) {
  deleteMealPlan(input: $input, condition: $condition) {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMealPlanMutationVariables,
  APITypes.DeleteMealPlanMutation
>;
export const createOption = /* GraphQL */ `mutation CreateOption(
  $input: CreateOptionInput!
  $condition: ModelOptionConditionInput
) {
  createOption(input: $input, condition: $condition) {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOptionMutationVariables,
  APITypes.CreateOptionMutation
>;
export const updateOption = /* GraphQL */ `mutation UpdateOption(
  $input: UpdateOptionInput!
  $condition: ModelOptionConditionInput
) {
  updateOption(input: $input, condition: $condition) {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOptionMutationVariables,
  APITypes.UpdateOptionMutation
>;
export const deleteOption = /* GraphQL */ `mutation DeleteOption(
  $input: DeleteOptionInput!
  $condition: ModelOptionConditionInput
) {
  deleteOption(input: $input, condition: $condition) {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOptionMutationVariables,
  APITypes.DeleteOptionMutation
>;
export const createRecordOption = /* GraphQL */ `mutation CreateRecordOption(
  $input: CreateRecordOptionInput!
  $condition: ModelRecordOptionConditionInput
) {
  createRecordOption(input: $input, condition: $condition) {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecordOptionMutationVariables,
  APITypes.CreateRecordOptionMutation
>;
export const updateRecordOption = /* GraphQL */ `mutation UpdateRecordOption(
  $input: UpdateRecordOptionInput!
  $condition: ModelRecordOptionConditionInput
) {
  updateRecordOption(input: $input, condition: $condition) {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecordOptionMutationVariables,
  APITypes.UpdateRecordOptionMutation
>;
export const deleteRecordOption = /* GraphQL */ `mutation DeleteRecordOption(
  $input: DeleteRecordOptionInput!
  $condition: ModelRecordOptionConditionInput
) {
  deleteRecordOption(input: $input, condition: $condition) {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecordOptionMutationVariables,
  APITypes.DeleteRecordOptionMutation
>;
export const createProfile = /* GraphQL */ `mutation CreateProfile(
  $input: CreateProfileInput!
  $condition: ModelProfileConditionInput
) {
  createProfile(input: $input, condition: $condition) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProfileMutationVariables,
  APITypes.CreateProfileMutation
>;
export const updateProfile = /* GraphQL */ `mutation UpdateProfile(
  $input: UpdateProfileInput!
  $condition: ModelProfileConditionInput
) {
  updateProfile(input: $input, condition: $condition) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProfileMutationVariables,
  APITypes.UpdateProfileMutation
>;
export const deleteProfile = /* GraphQL */ `mutation DeleteProfile(
  $input: DeleteProfileInput!
  $condition: ModelProfileConditionInput
) {
  deleteProfile(input: $input, condition: $condition) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProfileMutationVariables,
  APITypes.DeleteProfileMutation
>;
export const createRecipe = /* GraphQL */ `mutation CreateRecipe(
  $input: CreateRecipeInput!
  $condition: ModelRecipeConditionInput
) {
  createRecipe(input: $input, condition: $condition) {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecipeMutationVariables,
  APITypes.CreateRecipeMutation
>;
export const updateRecipe = /* GraphQL */ `mutation UpdateRecipe(
  $input: UpdateRecipeInput!
  $condition: ModelRecipeConditionInput
) {
  updateRecipe(input: $input, condition: $condition) {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecipeMutationVariables,
  APITypes.UpdateRecipeMutation
>;
export const deleteRecipe = /* GraphQL */ `mutation DeleteRecipe(
  $input: DeleteRecipeInput!
  $condition: ModelRecipeConditionInput
) {
  deleteRecipe(input: $input, condition: $condition) {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecipeMutationVariables,
  APITypes.DeleteRecipeMutation
>;
export const createRecipeIngredientsGroup = /* GraphQL */ `mutation CreateRecipeIngredientsGroup(
  $input: CreateRecipeIngredientsGroupInput!
  $condition: ModelRecipeIngredientsGroupConditionInput
) {
  createRecipeIngredientsGroup(input: $input, condition: $condition) {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRecipeIngredientsGroupMutationVariables,
  APITypes.CreateRecipeIngredientsGroupMutation
>;
export const updateRecipeIngredientsGroup = /* GraphQL */ `mutation UpdateRecipeIngredientsGroup(
  $input: UpdateRecipeIngredientsGroupInput!
  $condition: ModelRecipeIngredientsGroupConditionInput
) {
  updateRecipeIngredientsGroup(input: $input, condition: $condition) {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRecipeIngredientsGroupMutationVariables,
  APITypes.UpdateRecipeIngredientsGroupMutation
>;
export const deleteRecipeIngredientsGroup = /* GraphQL */ `mutation DeleteRecipeIngredientsGroup(
  $input: DeleteRecipeIngredientsGroupInput!
  $condition: ModelRecipeIngredientsGroupConditionInput
) {
  deleteRecipeIngredientsGroup(input: $input, condition: $condition) {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRecipeIngredientsGroupMutationVariables,
  APITypes.DeleteRecipeIngredientsGroupMutation
>;
export const createScheduledMessage = /* GraphQL */ `mutation CreateScheduledMessage(
  $input: CreateScheduledMessageInput!
  $condition: ModelScheduledMessageConditionInput
) {
  createScheduledMessage(input: $input, condition: $condition) {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScheduledMessageMutationVariables,
  APITypes.CreateScheduledMessageMutation
>;
export const updateScheduledMessage = /* GraphQL */ `mutation UpdateScheduledMessage(
  $input: UpdateScheduledMessageInput!
  $condition: ModelScheduledMessageConditionInput
) {
  updateScheduledMessage(input: $input, condition: $condition) {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduledMessageMutationVariables,
  APITypes.UpdateScheduledMessageMutation
>;
export const deleteScheduledMessage = /* GraphQL */ `mutation DeleteScheduledMessage(
  $input: DeleteScheduledMessageInput!
  $condition: ModelScheduledMessageConditionInput
) {
  deleteScheduledMessage(input: $input, condition: $condition) {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduledMessageMutationVariables,
  APITypes.DeleteScheduledMessageMutation
>;
export const createStickyNote = /* GraphQL */ `mutation CreateStickyNote(
  $input: CreateStickyNoteInput!
  $condition: ModelStickyNoteConditionInput
) {
  createStickyNote(input: $input, condition: $condition) {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStickyNoteMutationVariables,
  APITypes.CreateStickyNoteMutation
>;
export const updateStickyNote = /* GraphQL */ `mutation UpdateStickyNote(
  $input: UpdateStickyNoteInput!
  $condition: ModelStickyNoteConditionInput
) {
  updateStickyNote(input: $input, condition: $condition) {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStickyNoteMutationVariables,
  APITypes.UpdateStickyNoteMutation
>;
export const deleteStickyNote = /* GraphQL */ `mutation DeleteStickyNote(
  $input: DeleteStickyNoteInput!
  $condition: ModelStickyNoteConditionInput
) {
  deleteStickyNote(input: $input, condition: $condition) {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStickyNoteMutationVariables,
  APITypes.DeleteStickyNoteMutation
>;
export const createSystemProperty = /* GraphQL */ `mutation CreateSystemProperty(
  $input: CreateSystemPropertyInput!
  $condition: ModelSystemPropertyConditionInput
) {
  createSystemProperty(input: $input, condition: $condition) {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSystemPropertyMutationVariables,
  APITypes.CreateSystemPropertyMutation
>;
export const updateSystemProperty = /* GraphQL */ `mutation UpdateSystemProperty(
  $input: UpdateSystemPropertyInput!
  $condition: ModelSystemPropertyConditionInput
) {
  updateSystemProperty(input: $input, condition: $condition) {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSystemPropertyMutationVariables,
  APITypes.UpdateSystemPropertyMutation
>;
export const deleteSystemProperty = /* GraphQL */ `mutation DeleteSystemProperty(
  $input: DeleteSystemPropertyInput!
  $condition: ModelSystemPropertyConditionInput
) {
  deleteSystemProperty(input: $input, condition: $condition) {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSystemPropertyMutationVariables,
  APITypes.DeleteSystemPropertyMutation
>;
export const createTaskList = /* GraphQL */ `mutation CreateTaskList(
  $input: CreateTaskListInput!
  $condition: ModelTaskListConditionInput
) {
  createTaskList(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskListMutationVariables,
  APITypes.CreateTaskListMutation
>;
export const updateTaskList = /* GraphQL */ `mutation UpdateTaskList(
  $input: UpdateTaskListInput!
  $condition: ModelTaskListConditionInput
) {
  updateTaskList(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskListMutationVariables,
  APITypes.UpdateTaskListMutation
>;
export const deleteTaskList = /* GraphQL */ `mutation DeleteTaskList(
  $input: DeleteTaskListInput!
  $condition: ModelTaskListConditionInput
) {
  deleteTaskList(input: $input, condition: $condition) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskListMutationVariables,
  APITypes.DeleteTaskListMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createContact = /* GraphQL */ `mutation CreateContact(
  $input: CreateContactInput!
  $condition: ModelContactConditionInput
) {
  createContact(input: $input, condition: $condition) {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContactMutationVariables,
  APITypes.CreateContactMutation
>;
export const updateContact = /* GraphQL */ `mutation UpdateContact(
  $input: UpdateContactInput!
  $condition: ModelContactConditionInput
) {
  updateContact(input: $input, condition: $condition) {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContactMutationVariables,
  APITypes.UpdateContactMutation
>;
export const deleteContact = /* GraphQL */ `mutation DeleteContact(
  $input: DeleteContactInput!
  $condition: ModelContactConditionInput
) {
  deleteContact(input: $input, condition: $condition) {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContactMutationVariables,
  APITypes.DeleteContactMutation
>;
export const createUserScheduledMessage = /* GraphQL */ `mutation CreateUserScheduledMessage(
  $input: CreateUserScheduledMessageInput!
  $condition: ModelUserScheduledMessageConditionInput
) {
  createUserScheduledMessage(input: $input, condition: $condition) {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserScheduledMessageMutationVariables,
  APITypes.CreateUserScheduledMessageMutation
>;
export const updateUserScheduledMessage = /* GraphQL */ `mutation UpdateUserScheduledMessage(
  $input: UpdateUserScheduledMessageInput!
  $condition: ModelUserScheduledMessageConditionInput
) {
  updateUserScheduledMessage(input: $input, condition: $condition) {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserScheduledMessageMutationVariables,
  APITypes.UpdateUserScheduledMessageMutation
>;
export const deleteUserScheduledMessage = /* GraphQL */ `mutation DeleteUserScheduledMessage(
  $input: DeleteUserScheduledMessageInput!
  $condition: ModelUserScheduledMessageConditionInput
) {
  deleteUserScheduledMessage(input: $input, condition: $condition) {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserScheduledMessageMutationVariables,
  APITypes.DeleteUserScheduledMessageMutation
>;
